import React from 'react';
import { BrandProvider } from '../../context/brand';
import { getCurrentBrand } from '../../lib/brands';
import { BrandTitle } from './brandTitle';

interface Props {
  children: React.ReactNode
}

export function BrandWrapper(props: Props) {
  const { children } = props;
  const brand = getCurrentBrand();

  return (
    <BrandProvider brand={brand}>
      <BrandTitle />
      {children}
    </BrandProvider>
  );
}
